// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { DEFAULT_RATING, EMPTY_STRING } from '~/utils/constants/common';
import { IFormReview } from '~/utils/interface/review';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      rating: yup.number().required(t('common_validate_field_required', { ns: 'common/base' })),
    })
    .required();
};

export const defaultValuesForm: IFormReview = {
  rating: DEFAULT_RATING,
  token: EMPTY_STRING,
  content: EMPTY_STRING,
  employees: [],
};
